import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import useMedia from "utils/useMedia"
import MarketoForm from "components/MarketoForm"
import ReactPlayer from "react-player"
import GlobalButton from "./buttons/GlobalButton"
import ContentWidth from "./ContentWidth"
import StyledLink from "./StyledLink"

const SimpleCenteredContent = ({ content }) => {
  const mobileImage = content?.mobileImage?.sourceUrl
    ? content?.mobileImage?.sourceUrl
    : content?.image?.sourceUrl
  const image = content?.image?.sourceUrl

  const CenteredImage = useMedia(image, image, image, mobileImage)
  const videoWidth = useMedia("912px", "63.333vw", "89.063vw", "87.85vw")
  const videoHeight = useMedia("512px", "35.556vw", "50vw", "49.299vw")

  return (
    <ContentWidth>
      <Wrapper>
        <ContentDiv textColor={content?.textColor}>
          {content?.eyebrowCopy && <Eyebrow>{content?.eyebrowCopy}</Eyebrow>}
          {content?.headline && <Header>{content?.headline}</Header>}
          {content?.bodyCopy && (
            <Body dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
          )}
          {content?.linkText && content?.button === true && (
            <GlobalButton fill href={content.linkUrl}>
              {content?.linkText}
            </GlobalButton>
          )}
          {content?.linkText && content?.button !== true && (
            <StyledLink href={content.linkUrl}>{content?.linkText}</StyledLink>
          )}
          {content.formId && (
            <MarginDiv>
              <MarketoForm id={2091} />
            </MarginDiv>
          )}
          {content?.image && (
            <Image alt={content?.image?.altText} src={CenteredImage} />
          )}
          {content?.video && (
            <MarginDiv>
              <Video
                url={content?.video}
                controls={true}
                light={content?.videoThumbnail?.sourceUrl}
                playing={true}
                volume={1}
                muted={false}
                width={videoWidth}
                height={videoHeight}
              />
            </MarginDiv>
          )}
        </ContentDiv>
      </Wrapper>
    </ContentWidth>
  )
}

export default SimpleCenteredContent

const Video = styled(ReactPlayer)`
  .react-player__shadow {
    display: none !important;
  }
`

const MarginDiv = styled.div`
  margin-top: 2.778vw;

  ${media.fullWidth} {
    margin-top: 40px;
  }

  ${media.tablet} {
    margin-top: 3.906vw;
  }

  ${media.mobile} {
    margin-top: 7.477vw;
  }
`

const Image = styled.img`
  object-fit: contain;
  height: auto;
  width: 63.333vw;
  border-radius: 1.667vw;
  margin-top: 2.778vw;

  ${media.fullWidth} {
    width: 912px;
    border-radius: 24px;
    margin-top: 40px;
  }

  ${media.tablet} {
    width: 89.063vw;
    border-radius: 2.344vw;
    margin-top: 3.906vw;
  }

  ${media.mobile} {
    width: 80.85vw;
    border-radius: 5.607vw;
    margin-top: 7.477vw;
  }
`
const Link = styled.a`
  ${text.bodyMdBold};
`
const Body = styled.p`
  ${text.bodyMd};
  margin-bottom: 1.389vw;
  width: 63.333vw;

  ${media.fullWidth} {
    margin-bottom: 20px;
    width: 912px;
  }

  ${media.tablet} {
    margin-bottom: 1.953vw;
    width: 80.469vw;
  }

  ${media.mobile} {
    margin-bottom: 4.673vw;
    width: 87.85vw;
  }
`
const Header = styled.h2`
  ${text.h2};
  margin-bottom: 2.778vw;

  ${media.fullWidth} {
    margin-bottom: 40px;
  }

  ${media.tablet} {
    margin-bottom: 3.906vw;
  }

  ${media.mobile} {
    ${text.h2};
    margin-bottom: 7.477vw;
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow};
  margin-bottom: 1.667vw;

  ${media.fullWidth} {
    margin-bottom: 24px;
  }

  ${media.tablet} {
    margin-bottom: 2.344vw;
  }

  ${media.mobile} {
    margin-bottom: 4.673vw;
  }
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${props => (props.textColor ? `#${props.textColor}` : "white")};
  width: 79.444vw;

  ${media.fullWidth} {
    width: 1144px;
  }

  ${media.tablet} {
    width: 92.188vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const Wrapper = styled.div`
  height: auto;
  width: 100vw;
  padding: 0 10.278vw;

  ${media.fullWidth} {
    padding: 0 148px;
    width: 1440px;
  }

  ${media.tablet} {
    padding: 0 3.906vw;
  }

  ${media.mobile} {
    padding: 0 6.075vw;
  }
`
